/** 通用 */
export const useCommonStore = defineStore('common', () => {
  /** 是否正在讀取 */
  const loading = ref<{ show: boolean }>({ show: false })

  /** 狀態欄 */
  const snack = ref({
    message: '',
    action: 'success',
    show: false,
    timer: null
  })

  let timer: NodeJS.Timeout

  function setLoading(data: { show: boolean }) {
    loading.value = data
  }

  function setSnackState(options: {
    action: string
    show: boolean
    message: string
  }) {
    const { action, show, message } = options
    snack.value.show = show

    if (message) {
      snack.value.action = action
      snack.value.message = message
    }
  }

  function setSnack(options: { action: string; message: string }) {
    const { action, message } = options

    setSnackState({ show: true, action, message })
    clearTimeout(timer)

    timer = setTimeout(() => {
      setSnackState({ show: false, message: '', action: 'success' })
    }, 1500)
  }

  return {
    snack,
    loading,
    setLoading,
    setSnack
  }
})
